/**
 * Finds the minimum element in an array based on a selector function
 */
export const minBy = <T>(array: T[], selector: (item: T) => number): T | undefined => {
  if (array.length === 0) return undefined

  return array.reduce((min, current) => (selector(current) < selector(min) ? current : min))
}
